export default __webpack_public_path__ + "navigation-examples-custom-segue-960-928a8aabd54a0d48d9ce0b747f8c6c74.webp";